import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconPhotoCameraStyle0 = cosmosIconCss;

const CosmosIconPhotoCamera$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPhotoCamera extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '393d6240bdab8009c70d58ba52e1fad6977473b0', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'c660fa5e29e332c503832a8e0a4fedf342261087', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7ab9ab5c592e7c3bf9467765b5314529441ffd97', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.309 4a.5.5 0 0 0-.447.276L7 6H3.5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5H15l-.862-1.724A.5.5 0 0 0 13.691 4H8.309Zm4.764 1.5.862 1.724a.5.5 0 0 0 .447.276H17.5v9h-13v-9h3.118a.5.5 0 0 0 .447-.276L8.927 5.5h4.146ZM11 8a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm0 1.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconPhotoCameraStyle0; }
}, [1, "cosmos-icon-photo-camera", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-photo-camera"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-photo-camera":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPhotoCamera$1);
            }
            break;
    } });
}

const CosmosIconPhotoCamera = CosmosIconPhotoCamera$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPhotoCamera, defineCustomElement };
